/* callec-series.js — シリーズ紹介ページの控えめな動き
   1) 文字ブロックの出現(opacity/transform のみ、IntersectionObserver)
   2) 洗濯泡のあしらい(セクションが画面に入った時に一度だけ立ちのぼる)
   JS が無い/reduced-motion の環境では何も隠さない(CSS 側が既定表示)。 */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;
  var root = document.documentElement;
  root.classList.add('cs-js');

  var reveal = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-inview'); reveal.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });

  var bubbles = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-playing'); }
      else { e.target.classList.remove('is-playing'); }
    });
  }, { threshold: 0.25 });

  function init(scope) {
    (scope || document).querySelectorAll('[data-cs-reveal]:not(.is-inview)').forEach(function (el) { reveal.observe(el); });
    (scope || document).querySelectorAll('.cs-bubbles').forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var n = parseInt(el.dataset.count || '6', 10);
      for (var i = 0; i < n; i++) {
        var b = document.createElement('span');
        b.className = 'cs-bubble';
        b.style.setProperty('--x', (8 + Math.random() * 84).toFixed(1) + '%');
        b.style.setProperty('--s', (14 + Math.random() * 30).toFixed(0) + 'px');
        b.style.setProperty('--d', (5 + Math.random() * 5).toFixed(1) + 's');
        b.style.setProperty('--w', (0.2 + Math.random() * 1.4).toFixed(1) + 's');
        b.style.setProperty('--sway', ((Math.random() - 0.5) * 40).toFixed(0) + 'px');
        el.appendChild(b);
      }
      bubbles.observe(el);
    });
  }
  init();
  /* テーマエディターでセクションを再描画した時にも効かせる */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
